var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main-layout"},[_c('Header'),_c('main',{staticClass:"app-content",attrs:{"id":"content"}},[_c('div',{staticClass:"app-page"},[_vm._t("default")],2)]),_c('Footer'),_c('feedbackBtn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }